module.exports = __webpack_public_path__ + "img/mobile_news_top_img.fa7b4f06.jpg";